import React from 'react'

import { LentaLogo } from '@app/components'
import { LntButton } from '@app/components/base'

import { BUTTON_TYPE, SIZE } from '@app/constants'

import styles from './styles.module.scss'

import type { AuthCardProps } from './types'

export const AuthCard: React.FC<AuthCardProps> = ({ onAuthorization }) => {
  return (
    <section className={ styles.authCard__card }>
      <LentaLogo />

      <header className={ styles.authCard__header }>
        <h4>Добро пожаловать</h4>
        <p className={ styles.authCard__description }>Нажмите кнопку для авторизации</p>
      </header>

      <LntButton
        className={ styles.authCard__authorizationButton }
        size={ SIZE.large }
        type={ BUTTON_TYPE.secondary }
        onClick={ onAuthorization }
      >
        Авторизация
      </LntButton>
    </section>
  )
}
